<template>
  <div
    class="bokeh fixed-full no-pointer-events"
    :class="{'background': !transparent}"
  >
    <span v-for="i in amountOfSpans" :key="i" />
  </div>
</template>

<script>
export default {
  props: {
    transparent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    amountOfSpans () {
      return this.windowWidth < 1024 ? 3 : 8
    }
  }
}
</script>

<style scoped lang="scss">
@use "sass:math";

$particleSize: 50vmin;
$animationDuration: 60; // seconds
$amount: 8;

.background {
  background-color: #fff;

  &:after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, #FFF, rgba(255,255,255,0));
    z-index: 1;
  }
}

.bokeh:not(.background) {
  opacity: 0.6;
}

.bokeh span {
  width: $particleSize;
  height: $particleSize;
  border-radius: $particleSize;
  backface-visibility: hidden;
  position: absolute;
  animation-name: move;
  animation-duration: #{$animationDuration}s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  $colors: (
    rgba(37, 104, 239, 0.75),
    rgba(255, 159, 123, 0.9),
    rgba(110, 215, 244, 0.9),
    rgba(38, 50, 56, 0.7)
  );

  @for $i from 1 through $amount {
    &:nth-child(#{$i}) {
      color: nth($colors, random(length($colors)));
      top: random(100) * 1%;
      left: random(100) * 1%;
      animation-duration: math.div(random($animationDuration * 10), 10) * 1s + 10s;
      animation-delay: math.div(random(($animationDuration + 10) * 10), 10) * -1s;
      transform-origin: (random(50) - 25) * 1vw (random(50) - 25) * 1vh;
      $blurRadius: (random() + 0.5) * $particleSize * 0.5;
      $x: 1;
      @if random() > 0.5 {
        $x: -1;
      }
      box-shadow: ($particleSize * 2 * $x) 0 $blurRadius currentColor;
    }
  }
}

@keyframes move {
  100% {
    transform: translate3d(0, 0, 1px) rotate(360deg);
  }
}
</style>
